import { ClientKind, useClientKind } from '@/features/tr-reportsettings/clientKind';

export const SOLE_TRADER_CLIENT_TYPE = ClientKind.SoleTrader;

/** Sole traders and (ordinary) partnerships file no accounts at Companies House: no submission, filing or deadlines. */
export const filesNothingAtCompaniesHouse = (clientType: number | null | undefined) =>
  clientType === ClientKind.SoleTrader || clientType === ClientKind.Partnership;

/** The client's type (0 Limited, 1 Sole trader, 2 Partnership, 3 LLP), or undefined until it has been read. */
export function useClientType(clientId: string | null | undefined): number | undefined {
  return useClientKind(clientId)?.clientType;
}
